<label class="switch">
  <input type="checkbox" [checked]="checked" (change)="onChanged()">
  <span class="slider round"></span>
</label>
<label class="label">{{ label }}</label>
